import * as React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

export function NoResults() {
  const theme = useTheme()
  return (
    <Stack
      sx={{
        alignItems: 'center',
        flexDirection: 'column',
        padding: theme.spacing(2),
      }}
    >
      <img
        src="/static-assets/icons/global-search/no-results.svg"
        alt="no results"
      />
      <Typography variant="h6">No results found</Typography>
      <Typography variant="body2">
        It seems we can’t find any results based on your search.
      </Typography>
    </Stack>
  )
}
